import {h, Fragment} from "preact"
import { useState } from "preact/hooks"

export default function Select({ value, onChange, options, label }) {
    const [active, setActive] = useState(false);

    return (
        <div class="link-dropdown link-dropdown--right-aligned">
            <div class="visually-hidden" id="sort-dropdown-heading">{label}</div>
            <button 
                class="link-dropdown__button notabutton" 
                aria-expanded={active}
                aria-controls="sort-dropdown-options" 
                aria-describedby="sort-dropdown-heading"
                onClick={() => {setActive(true)}}
                style={'width: 140px'}
            >
                <span class="link-dropdown__button-text">{value}</span>
                <span class="link-dropdown__button-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down">
                        <title>Down</title>
                        <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                </span>
            </button>
            <div class="link-dropdown__options" id="sort-dropdown-options">
                {options.map(option => ( 
                    <span class="link-dropdown__link" sortValue={option.value} 
                      onClick={(e) => {onChange(e); setActive(false);}}>
                        {option.label}
                    </span>
                ))}
            </div>
        </div>
    )
}
